import React from 'react';
import PropTypes from 'prop-types';
import Grid from "@material-ui/core/Grid";
import DeviceWidget from "./DeviceWidget";

const DevicesGrid = ({serials, ...props}) => {
    const cellSize = (serials.length < 4) ? 6 : 4;
    const mainSerial = serials[0];
    const otherSerials = serials.slice(1);

    return (
        <Grid container spacing={3}>
            <Grid item xs={cellSize * 2}>
                <DeviceWidget
                    expanded
                    key={mainSerial}
                    serial={mainSerial}
                />
            </Grid>
            {otherSerials.map(serial => (
                <Grid item xs={cellSize}>
                    <DeviceWidget
                        key={serial}
                        serial={serial}
                        selected={serial === mainSerial}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

DevicesGrid.propTypes = {
    serials: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default DevicesGrid;
